module.exports = __webpack_public_path__ + "static/media/logo.7f7831e9.svg";